import { Box, Modal } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import "./styles.css";
import "./ImagesModal.css";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";

const ImagesModal = ({
  OpenImagesModal,
  handleCloseImagesDetailModal,
  Properties,
  Images,
}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  //   const [Images, setImages] = useState(null);

  //   useEffect(() => {
  //     async function fetchData() {
  //       let images = [];
  //       let recItems = [];
  //       let targetImage = 0;
  //       let totalImages = 0;

  //       const getAndAddImage = async () => {
  //         if (targetImage >= totalImages) {
  //           setImages([...images]);
  //           return;
  //         }
  //         const url = await getDownloadURL(recItems[targetImage++]);
  //         images.push(url);
  //         await getAndAddImage();
  //       };

  //       let id = Properties.map((property) => {
  //         return property.id;
  //       });
  //       id = id.toString();
  //       console.log("idssssssssssss", id);

  //       listAll(ref(getStorage(), `/properties/${id}`)).then(
  //         async ({ items }) => {
  //           totalImages = items.length;
  //           recItems = items;

  //           items === 0 ? setImages([]) : await getAndAddImage();
  //         }
  //       );
  //     }
  //     fetchData();
  //   }, []);

  //   console.log("Propertiesssssss", Properties);
  //   console.log("objectidddd", Images);
  return (
    <Fragment>
      {/* Modal Start */}
      <div>
        <Modal
          open={OpenImagesModal}
          onClose={handleCloseImagesDetailModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="images-box-style">
            {/* {!Images && (
              <div>
                <p>Loading...</p>
              </div>
            )} */}

            {/* {Images.length === 0 && (
              <Fragment>
                <SwiperSlide>
                  <img src="https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2Fproperty-avatar.jpg?alt=media&token=84c103e0-6469-4c87-9c14-c8d7f47b75c6" />
                </SwiperSlide>
              </Fragment>
            )} */}

            {!Images && (
              <Fragment>
                <p>Loading...</p>
              </Fragment>
            )}

            <Swiper
              style={{
                "--swiper-navigation-color": "#fff",
                "--swiper-pagination-color": "#fff",
              }}
              loop={true}
              spaceBetween={10}
              navigation={true}
              modules={[FreeMode, Navigation]}
              className="mySwiper2"
            >
              {Images &&
                Images?.map((imgUrl, index) => {
                  return (
                    <Fragment>
                      <SwiperSlide key={index}>
                        <img src={imgUrl} />
                      </SwiperSlide>
                    </Fragment>
                  );
                })}
            </Swiper>

            {/* <Swiper
              onSwiper={setThumbsSwiper}
              loop={true}
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className="mySwiper"
            >
              {Images.length === 0 && (
                <Fragment>
                  <SwiperSlide>
                    <img src="https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2Fproperty-avatar.jpg?alt=media&token=84c103e0-6469-4c87-9c14-c8d7f47b75c6" />
                  </SwiperSlide>
                </Fragment>
              )}
            </Swiper> */}
            <Swiper
              onSwiper={setThumbsSwiper}
              loop={true}
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation]}
              className="mySwiper"
            >
              {Images &&
                Images.map((imgUrl, index) => {
                  return (
                    <Fragment>
                      <SwiperSlide key={index}>
                        <img src={imgUrl} />
                      </SwiperSlide>
                    </Fragment>
                  );
                })}
            </Swiper>
          </Box>
        </Modal>
      </div>
      {/* Modal End */}
    </Fragment>
  );
};

export default ImagesModal;
